import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import ClockIcon from '@material-ui/icons/Schedule';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';

import AuthUserContainer from '../../containers/AuthUser';
import TicketTable from '../../components/table/TicketTable';

import TicketContainer from '../../containers/Ticket/Ticket';

import { getGlobalClasses } from '../../themes';
import FilterHeader from '../../components/table/FilterHeader';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		fleet: {
			textTransform: 'uppercase',
			paddingRight: 5,
			color: '#777',
		},
		detailLabel: {
			fontWeight: 500,
			paddingRight: 5,
		},
		detailValue: {},
	};
};

const BILLING_GROUP_ID = 491;

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

class TicketList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'ticketId',
			secondOrder: 'desc',
			secondOrderBy: 'ticketId',

			filter: '',
			tabIndex: 0,
			filterMap: {},
			isViewDialogOpen: false,

			pendingRows: undefined,
			issuedRows: undefined,
		};
	}

	componentDidMount() {
		const { billingTickets, searchTickets } = this.props;

		const newState = {};
		if (!billingTickets) {
			searchTickets({
				isBilling: true,
				assignedToUserIds: [BILLING_GROUP_ID],
				afterDate: moment().subtract(10, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const openTickets = [];
			const closedTickets = [];
			billingTickets.forEach((ticket) => {
				if (ticket.status === 'open') {
					openTickets.push(ticket);
				} else {
					closedTickets.push(ticket);
				}
			});

			newState.openTickets = openTickets;
			newState.closedTickets = closedTickets;
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.billingTickets !== this.props.billingTickets) {
			const openTickets = [];
			const closedTickets = [];
			this.props.billingTickets.forEach((ticket) => {
				if (ticket.status === 'open') {
					openTickets.push(ticket);
				} else {
					closedTickets.push(ticket);
				}
			});

			newState.openTickets = openTickets;
			newState.closedTickets = closedTickets;
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	handleFilter = (event) => {
		this.setState({ filter: event.target.value });
	};

	render() {
		const { classes, theme, ticketCategoryMap, ticketSchemaMap, userMap, history } = this.props;
		const { filter, openTickets, closedTickets } = this.state;

		if (this.props.authUser?.role === 'driver') {
			return <div>You are not authorized to view this page.</div>;
		}

		return (
			<Fragment>
				<FilterHeader
					value={this.state.filter}
					onChange={this.handleFilter}
					label={'Billing Tickets'}
					buttonText="Open Billing Ticket"
					url="/ticket/add"
					canMakeUpdates={true}
				/>

				<AppBar position="static" color="default">
					<Tabs
						value={this.state.tabIndex}
						onChange={this.handleTabChange}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
						centered
					>
						<Tab label="Open Billing Tickets" icon={<ClockIcon />} />
						<Tab label="Recently Completed" icon={<CheckIcon />} />
					</Tabs>
				</AppBar>
				<Paper className={classes.globalMainPaper}>
					<SwipeableViews
						axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
						index={this.state.tabIndex}
						onChangeIndex={this.handleChangeTabIndex}
					>
						<TabContainer dir={theme.direction}>
							<TicketTable
								tickets={openTickets}
								filter={filter}
								ticketSchemaMap={ticketSchemaMap}
								ticketCategoryMap={ticketCategoryMap}
								userMap={userMap}
								history={history}
							/>
						</TabContainer>
						<TabContainer dir={theme.direction}>
							<TicketTable
								tickets={closedTickets}
								filter={filter}
								ticketSchemaMap={ticketSchemaMap}
								ticketCategoryMap={ticketCategoryMap}
								userMap={userMap}
								history={history}
							/>
						</TabContainer>
					</SwipeableViews>
				</Paper>
			</Fragment>
		);
	}
}

TicketList.propTypes = {
	classes: PropTypes.object.isRequired,

	searchTickets: PropTypes.func.isRequired,
	openTickets: PropTypes.array,
	closedTickets: PropTypes.array,

	ticketCategoryMap: PropTypes.object,
	ticketSchemaMap: PropTypes.object,
	userMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TicketContainer,
])(TicketList);
